import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Tallyho',
    description: 'Split travel costs with your group. Log shared expenses as you go, see who owes whom, and settle up with the fewest payments. Free, no sign-up.',
    url: getOrigin(),
    ogImage: 'https://tallyho.cdn.modulify.website/images/share/tallyho-share.jpg'
}
